/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { MDIStrictHttpResponse } from '../../mdi-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { KeyValueModel } from '../../models/key-value-model';

export interface MasterDataMedicalAidGet$Params {
  isoCountryCode?: string;
}

export function masterDataMedicalAidGet(http: HttpClient, rootUrl: string, params?: MasterDataMedicalAidGet$Params, context?: HttpContext): Observable<MDIStrictHttpResponse<Array<KeyValueModel>>> {
  const rb = new RequestBuilder(rootUrl, masterDataMedicalAidGet.PATH, 'get');
  if (params) {
    rb.query('isoCountryCode', params.isoCountryCode, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as MDIStrictHttpResponse<Array<KeyValueModel>>;
    })
  );
}

masterDataMedicalAidGet.PATH = '/MasterData/MedicalAid';
